import React from "react";
import usePeriod from "../../hooks/period.use";
import { useNavigate } from "react-router-dom";

function AlertPeriod() {
  const navigate = useNavigate();
  const { currentPeriod } = usePeriod();

  return (
    <div className="alert alert-primary d-flex align-items-center p-5 mb-0">
      <i className="ki-duotone ki-shield-tick fs-2hx text-success me-4">
        <span className="path1" />
        <span className="path2" />
      </i>

      <div className="d-flex flex-column">
        <h4 className="mb-1 text-primary">¡Atención!</h4>
        <span>
          Estas trabajando sobre el período <b>{currentPeriod.name}</b>.
        </span>
        <span>
          Puedes seleccionar otro periodo o negocio{" "}
          <button className="btn btn-link p-0 m-0 btn-color-primary text-decoration-underline" onClick={() => navigate('/select-period')}>
            aquí
          </button>
        </span>
      </div>
    </div>
  );
}

export default AlertPeriod;
